/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { SurveyFormAnswer } from './surveyFormAnswer'

/**
 * PII 混在フォームの一括送信入力（#264）。
フォーム全体を単一トランザクションで atomic に振り分け保存する（部分保存なし）。
scenarioId はパスから、設問文・選択肢ラベルはサーバ側で解決するため受け取らない。
 */
export interface SurveySubmissionInput {
  /** フォームの全回答（非PII設問＋リード項目が混在しうる） */
  answers: SurveyFormAnswer[]
  /** 送信元 SURVEYノードのノードキー */
  nodeKey: string
  /** 視聴セッションID（クライアント生成・回答の冪等キー） */
  sessionId: string
}
